import { ThemeOptions } from '@mui/material/styles';

const muiPortalRoot = document.getElementById('mui-portal');

export default function Popper(): ThemeOptions['components'] {
  return {
    MuiPopper: {
      defaultProps: {
        container: muiPortalRoot,
      },
    },
  };
}
